import { render, staticRenderFns } from "./UnitDetail.vue?vue&type=template&id=62571426&scoped=true"
import script from "./UnitDetail.vue?vue&type=script&lang=js"
export * from "./UnitDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62571426",
  null
  
)

export default component.exports